export default function ImageTransformer(imageNode) {
  if (!imageNode) return null

  if (imageNode.rawTagName.toLowerCase() !== "figure") return null

  const jsonScriptNodes = imageNode.childNodes.filter(
    node =>
      node.rawTagName.toLowerCase() === "script" &&
      node.attrs["type"] === "application/json"
  )
  if (!jsonScriptNodes.length) return null

  const jsonScriptText = jsonScriptNodes[0].text
  if (!jsonScriptText) return null

  try {
    const jsonScriptObj = JSON.parse(jsonScriptText)
    if (!jsonScriptObj.image) return null

    return jsonScriptObj
  } catch (e) {
    return null
  }
}
